import React from "react";

export interface SpinnerIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const SpinnerIcon: React.FC<SpinnerIconProps> = ({
  color = "var(--colors-primary-500)",
  width = 45,
  height = 49.4,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.3322 26.9375C22.9985 26.4431 23.6218 25.9058 24.2022 25.2825C25.4488 23.9498 26.3946 22.4238 27.0394 20.6613C27.7057 18.8988 28.0281 17.0288 28.0281 15.0084C28.0281 12.7515 27.6412 10.7311 26.8459 8.96856C26.0722 7.18456 24.9975 5.67998 23.6863 4.43333C22.3537 3.18668 20.8491 2.21946 19.1726 1.55314C17.4961 0.886832 15.7766 0.542928 13.9926 0.542928C11.8647 0.542928 9.9517 0.908326 8.23218 1.66061C6.51267 2.4129 5.02958 3.44461 3.80443 4.77724C2.57927 6.10986 1.63354 7.65742 0.988722 9.39843C0.322409 11.1609 0 13.0309 0 15.0513C0 17.3082 0.386891 19.3286 1.16067 21.1126C1.93446 22.8966 2.98766 24.4227 4.32028 25.6694C5.65291 26.916 7.15748 27.8832 8.83401 28.5495C10.5105 29.2159 12.2301 29.5598 13.9926 29.5598C16.013 29.5598 17.84 29.2159 19.4735 28.5495C21.0856 31.0428 24.2022 33.88 26.8889 33.7081C28.1786 33.6221 28.6299 33.4502 30.0056 33.0848L30.0485 32.6549C26.5665 32.3755 24.1377 29.5598 22.3322 26.9375ZM10.2741 27.1739C9.09194 26.4861 8.08172 25.5189 7.24346 24.2937C6.4052 23.0686 5.76038 21.6285 5.3305 19.9949C4.90062 18.3614 4.66419 16.5989 4.66419 14.7074C4.66419 12.3216 4.9651 10.1507 5.58843 8.21627C6.21175 6.28181 7.20047 4.73425 8.5331 3.59507C9.86572 2.45589 11.6282 1.87555 13.7776 1.87555C15.2392 1.87555 16.5718 2.21946 17.7325 2.90726C18.9147 3.59507 19.9249 4.5623 20.7417 5.78745C21.5799 7.01261 22.2032 8.4527 22.6546 10.0862C23.0845 11.7198 23.3209 13.4823 23.3209 15.3523C23.3209 17.7381 23.02 19.909 22.3967 21.8434C22.0313 22.9826 21.5584 23.9928 20.9351 24.8526C20.4837 24.1648 20.0753 23.5629 19.6885 23.1331C17.2596 19.995 12.1871 19.7585 8.98447 22.3593L9.32837 22.8536C13.1758 20.5968 16.5933 22.5527 18.6997 27.045C17.4961 27.8187 15.9915 28.1841 14.229 28.1841C12.7674 28.2056 11.4563 27.8617 10.2741 27.1739Z"
        fill={color}
      />
    </svg>
  );
};

export default SpinnerIcon;
